import { AnalyticsUtils } from '../../utils/analytics/AnalyticsUtils';
import { API } from './';
import { API_ENDPOINTS } from './api-endpoints.constant';
class TeamSettingService {
    constructor() {
        this.http = API;
    }
    fetchInviteData(paramToken) {
        if (paramToken) {
            return this.http.post(API_ENDPOINTS.INVITE, { token: paramToken });
        }
        return this.http.withMetadata({}).post(API_ENDPOINTS.INVITE);
    }
    removeTeamInvite(id) {
        return this.http.post(API_ENDPOINTS.REMOVE_INVITE, {
            device_id: AnalyticsUtils.getDeviceId() || 'NaN',
            ...(id && { id }),
        });
    }
    removeTeamMember(id) {
        return this.http.post(API_ENDPOINTS.REMOVE_INVITE, {
            id,
        });
    }
    joinTeam(teamToken) {
        return this.http
            .withMetadata({
            method: teamToken ? 'invite' : 'consent',
            device_id: AnalyticsUtils.getDeviceId() || 'NaN',
            token: teamToken,
        })
            .post(API_ENDPOINTS.JOIN_TEAM);
    }
    inviteMembers(members) {
        return this.http
            .withMetadata({
            members: members,
            device_id: AnalyticsUtils.getDeviceId() || 'NaN',
        })
            .post(API_ENDPOINTS.INVITE_MEMBERS);
    }
    inviteMembersForReview(members, videoId) {
        return this.http
            .withMetadata({
            members: members,
            device_id: AnalyticsUtils.getDeviceId() || 'NaN',
            intent: 'review',
            metadata: {
                video_id: parseInt(videoId),
            },
        })
            .post(API_ENDPOINTS.INVITE_MEMBERS);
    }
    getTeamData() {
        return this.http.get(API_ENDPOINTS.TEAM_DATA);
    }
    getTeamDataForReview(videoId) {
        return this.http.get(`${API_ENDPOINTS.TEAM_DATA_REVIEW}&video_id=${videoId}`);
    }
    updateTeamName(name) {
        return this.http
            .withMetadata({
            device_id: AnalyticsUtils.getDeviceId() || 'NaN',
            fields_to_update: ['team_name'],
            team_name: name,
        })
            .post(API_ENDPOINTS.UPDATE_TEAM_NAME);
    }
    updateTeam(data) {
        return this.http.withMetadata(data).post(API_ENDPOINTS.UPDATE_TEAM);
    }
    static getInstance() {
        if (!this.instance) {
            this.instance = new TeamSettingService();
        }
        return this.instance;
    }
}
const TeamSetting = TeamSettingService.getInstance();
export { TeamSetting };
